/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import {ErrorMessage, Field, useFormikContext} from 'formik'
import {Input} from '../../../../../_metronic/_partials/controls'
import PhoneInput from 'react-phone-input-2'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {
  getSectorList,
  getTeamSizeList,
  handleEmailVerifyDialog,
  handleOTPMode,
  handlePhoneNoVerifyDialog,
  handleSignUPGenerateOTP,
} from '../../../../../setup/redux/auth/actions'
import {RootState} from '../../../../../setup'
import {ICreateAccount} from '../CreateAccountWizardHelper'
//for autocomplete addresses
import GeoapifyGeocoderAutocompleteComponent from '../autocomplete/GeoapifyAutocompleteComponent'
import {FieldEditDialog} from '../../../../../_metronic/dialogs/FieldEditDialog'
import {
  handleNotificationWithToastify,
  maskEmail,
  maskMobileNumber,
  resetLocalStorageData,
  validateEmail,
  validatePhoneNumber,
} from '../../../../services/Functional'
import {Loader} from '../../../../services/Loader'
import {customSelectHoverStyles} from '../../../../services/Styles'
import CustomSelect from '../../../../components/common/Select'

const Step1: FC<{formik?: any; isModel?: boolean}> = ({formik, isModel}) => {
  const {sectors, teamSizeList, isPhoneVerifyDialog, isEmailVerifyDialog, actionsLoading}: any =
    useSelector<RootState>(
      (state) => ({
        actionsLoading: state.common.actionsLoading,
        sectors: state.auth.sectors,
        teamSizeList: state.auth.teamSizeList,
        isPhoneVerifyDialog: state.auth.isPhoneVerifyDialog,
        isEmailVerifyDialog: state.auth.isEmailVerifyDialog,
      }),
      shallowEqual
    )
  const dispatch: Dispatch<any> = useDispatch()
  const [sectorList, setSectorList] = useState([])
  const [teamSizeArray, setTeamSizeArray] = useState<{value: any; label: any}[]>([])
  const [OTPMode, setOTPMode] = useState('')
  const [firstTimeClicked, setFirstTimeClicked] = useState(true)
  const {values, setFieldValue, handleChange, handleBlur} = useFormikContext<ICreateAccount>()

  useEffect(() => {
    dispatch(getSectorList())
    dispatch(getTeamSizeList())
  }, [])

  useEffect(() => {
    if (sectors.length > 0) {
      const options = sectors.map((industry: any) => ({
        value: industry.id,
        label: industry.name,
      }))
      setSectorList(options)
    }
  }, [sectors])

  useEffect(() => {
    if (teamSizeList.length > 0) {
      const teamSizeOptionList = teamSizeList.map((teamsize: any) => ({
        value: teamsize.id,
        label: teamsize.size,
      }))
      setTeamSizeArray(teamSizeOptionList)
    }
  }, [teamSizeList])

  const [selectedSectors, setSelectedSectors] = useState<string[]>([...values.sectors])

  const handleSectorChange = (options: any) => {
    const selectedValues = options?.map?.((option: any) => option?.value)
    setSelectedSectors(selectedValues)
    setFieldValue('sectors', selectedValues)
  }

  const handleGenerateOTP = async (mode: string) => {
    const formattedPhoneNumber = `+${values?.country_code}${values?.phone}`
    let payload
    if (mode === 'mobile') {
      payload = {
        mobile_no: formattedPhoneNumber,
        mode: 'mobile',
        ...(!values.is_already_existing_user && values.user_id && {user_id: values.user_id}),
      }
    } else {
      payload = {
        email: values?.email,
        mode: 'email',
        ...(!values.is_already_existing_user && values.user_id && {user_id: values.user_id}),
      }
    }
    if (values.is_already_existing_user) {
      let response: any = await dispatch(handleOTPMode(payload))
      if (response.data.code === 200) {
        setOTPMode(mode)
        if (mode === 'mobile') {
          dispatch(handlePhoneNoVerifyDialog(true))
        } else {
          dispatch(handleEmailVerifyDialog(true))
        }
      } else {
        handleNotificationWithToastify(response.data)
      }
    } else {
      let response: any = await dispatch(handleSignUPGenerateOTP(payload))
      if (response.data.code === 200) {
        setFieldValue('user_id', response.data.data?.otpsent?.id)
        if (mode === 'mobile') {
          if (
            response.data.data?.otpsent?.name &&
            response.data.data?.otpsent?.is_active &&
            response.data.data?.otpsent?.is_invite_accepted &&
            response.data.data?.otpsent?.email
          ) {
            if (!values.is_existing_email_user) {
              setFieldValue('is_email_disabled', true)
              setFieldValue('is_existing_phone_user', true)
              setFieldValue('is_mask_email', true)
              setFieldValue('email', response.data.data?.otpsent?.email)
              setFieldValue('is_email_verified', false)
              setFieldValue('is_already_existing_user', true)
            }
          }
        } else {
          if (
            response.data.data?.otpsent?.name &&
            response.data.data?.otpsent?.is_active &&
            response.data.data?.otpsent?.is_invite_accepted &&
            response.data.data?.otpsent?.phone
          ) {
            if (!values.is_existing_phone_user) {
              setFieldValue('is_phone_no_disabled', true)
              setFieldValue('is_existing_email_user', true)
              setFieldValue('is_mask_phone_no', true)
              setFieldValue('country_code', response.data.data?.otpsent?.country_code)
              setFieldValue('phone', response.data.data?.otpsent?.phone)
              setFieldValue('is_phone_no_verfied', false)
              setFieldValue('is_already_existing_user', true)
            }
          }
        }
        handleNotificationWithToastify(response.data)
        setOTPMode(mode)
        if (mode === 'mobile') {
          dispatch(handlePhoneNoVerifyDialog(true))
        } else {
          dispatch(handleEmailVerifyDialog(true))
        }
      } else {
        handleNotificationWithToastify(response.data)
      }
    }
  }

  const onHideDialog = () => {
    if (firstTimeClicked) {
      setFieldValue('user_id', undefined)
      setFieldValue('is_already_existing_user', false)
    }
    dispatch(handlePhoneNoVerifyDialog(false))
    dispatch(handleEmailVerifyDialog(false))
    resetLocalStorageData()
  }

  const handleCloseDialog = () => {
    dispatch(handlePhoneNoVerifyDialog(false))
    dispatch(handleEmailVerifyDialog(false))
    resetLocalStorageData()
  }

  let signUpVerifyOTPPayload

  if (OTPMode === 'mobile') {
    signUpVerifyOTPPayload = {
      id: values.user_id,
      ...(!firstTimeClicked && {
        new_mobile_no: values.phone,
        new_country_code: values.country_code,
      }),
    }
  } else {
    signUpVerifyOTPPayload = {
      id: values.user_id,
      ...(!firstTimeClicked && {
        new_email: values.email,
      }),
    }
  }

  const handleverifiedOTP = async () => {
    setFirstTimeClicked(false)
    dispatch(handlePhoneNoVerifyDialog(false))
    dispatch(handleEmailVerifyDialog(false))
    if (OTPMode === 'mobile') {
      setFieldValue('is_phone_no_verfied', true)
    } else {
      setFieldValue('is_email_verified', true)
    }
  }

  return (
    <>
      {actionsLoading && <Loader />}
      <div className={`w-100 mt-2 card-body`}>
        <div className='row'>
          <div className='form-group'>
            <label className='form-label' htmlFor='companyName'>
              Company Name <span className='text-danger'>*</span>
            </label>
            <Field
              type='text'
              name='companyName'
              component={Input}
              placeholder='Enter Company Name'
              tabIndex={0}
            />
            <ErrorMessage name='companyName' component='div' className='text-danger mt-2' />
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-6'>
            <div className='form-group'>
              <label className='form-label' htmlFor='companyRegistrationNumber'>
                Company Registration Number
              </label>
              <Field
                type='text'
                name='companyRegistrationNumber'
                component={Input}
                placeholder='Enter Registration Number'
                tabIndex={0}
              />
              <ErrorMessage name='companyRegistrationNumber' component='div' className='text-danger mt-2' />
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='form-group'>
              <label className='form-label' htmlFor='vatNumber'>
                VAT Number
              </label>
              <Field
                type='text'
                name='vatNumber'
                component={Input}
                placeholder='Enter VAT Number'
                tabIndex={0}
              />
              <ErrorMessage name='vatNumber' component='div' className='text-danger mt-2' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label className='form-label' htmlFor='phone'>
                Mobile <span className='text-danger'>*</span>
              </label>
              {isModel || values.is_phone_no_disabled ? (
                <PhoneInput
                  buttonClass='flag_dropdown'
                  dropdownStyle={{backgroundColor: 'none'}}
                  enableSearch={true}
                  disableSearchIcon={true}
                  searchStyle={{width: '90%', margin: '0'}}
                  countryCodeEditable={false}
                  disabled={values.is_phone_no_verfied || values.is_phone_no_disabled}
                  country='gr'
                  value={values.phone ? values.country_code + values.phone : ''}
                  inputProps={{
                    name: 'phone',
                    id: 'phone',
                    required: true,
                    value: values.is_mask_phone_no
                      ? maskMobileNumber(values.phone, values.country_code)
                      : values.country_code + values.phone,
                  }}
                />
              ) : (
                <PhoneInput
                  buttonClass='flag_dropdown'
                  dropdownStyle={{backgroundColor: 'none'}}
                  enableSearch={true}
                  disableSearchIcon={true}
                  searchStyle={{width: '90%', margin: '0'}}
                  countryCodeEditable={false}
                  disabled={values.is_phone_no_verfied || values.is_phone_no_disabled}
                  country='gr'
                  inputProps={{
                    name: 'phone',
                    id: 'phone',
                    required: true,
                  }}
                  onBlur={(e: any) => {
                    e.preventDefault()
                  }}
                  onChange={(phone: any, data: any) => {
                    handleChange({
                      target: {
                        name: 'country_code',
                        value: data.dialCode,
                      },
                    })
                    let phone_number = phone.slice(data.dialCode.length)
                    handleChange({
                      target: {
                        name: 'phone',
                        value: phone_number,
                      },
                    })
                  }}
                />
              )}
              <div className='d-flex justify-content-between mt-2 gap-4'>
                <div>
                  <ErrorMessage name='phone' component='div' className='text-danger' />
                </div>
                {!values.is_phone_no_verfied ? (
                  <button
                    type='button'
                    onClick={() => handleGenerateOTP('mobile')}
                    className={`link-primary text-end btn btn-link p-0 `}
                    disabled={validatePhoneNumber(values.phone, values.country_code)}
                  >
                    <u>Verify</u>
                  </button>
                ) : (
                  <button
                    type='button'
                    className={`link-primary text-end btn btn-link p-0 `}
                    disabled={true}
                  >
                    <u>Verified</u>
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <label className='form-label' htmlFor='email'>
                Email <span className='text-danger'>*</span>
              </label>
              <Field
                type='email'
                name='email'
                component={Input}
                value={values.is_mask_email ? maskEmail(values.email) : values.email}
                disabled={values.is_email_verified || values.is_email_disabled}
                placeholder='Enter Email'
                tabIndex={0}
                onBlur={(e: any) => {
                  e.preventDefault()
                }}
              />
              <div className='d-flex justify-content-between mt-2 gap-4'>
                <div>
                  <ErrorMessage name='email' component='div' className='text-danger' />
                </div>
                {!values.is_email_verified ? (
                  <button
                    type='button'
                    onClick={() => handleGenerateOTP('email')}
                    className={`link-primary text-end btn btn-link p-0 `}
                    disabled={validateEmail(values.email)}
                  >
                    <u>Verify</u>
                  </button>
                ) : (
                  <button
                    type='button'
                    className={`link-primary text-end btn btn-link p-0 `}
                    disabled={true}
                  >
                    <u>Verified</u>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <div className='form-group'>
              <label className='form-label' htmlFor='address'>
                Address <span className='text-danger'>*</span>
              </label>
              <GeoapifyGeocoderAutocompleteComponent
                values={formik?.values?.address}
                placeholder='Type here to find address.'
                handleChange={(place: any) => {
                  if (place && place.properties && place.properties.formatted) {
                    const {formatted, country, city, state, postcode} = place.properties
                    handleChange({
                      target: {
                        name: 'address',
                        value: formatted,
                      },
                    })
                    if (country) {
                      let eventCountry = {
                        target: {
                          name: 'country',
                          value: country,
                        },
                      }
                      handleChange(eventCountry)
                    }
                    if (city) {
                      let eventCity = {
                        target: {
                          name: 'city',
                          value: city,
                        },
                      }
                      handleChange(eventCity)
                    }
                    if (state) {
                      let eventState = {
                        target: {
                          name: 'state',
                          value: state,
                        },
                      }
                      handleChange(eventState)
                    }
                    if (postcode) {
                      let eventPostcode = {
                        target: {
                          name: 'zipcode',
                          value: postcode,
                        },
                      }
                      handleChange(eventPostcode)
                    }
                    if (country) {
                      setFieldValue('country', country.toString())
                    }
                    if (city) {
                      setFieldValue('city', city.toString())
                    }
                  }
                }}
              />
              <ErrorMessage name='address' component='div' className='text-danger mt-2' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label className='form-label' htmlFor='city'>
                City <span className='text-danger'>*</span>
              </label>
              <Field
                type='text'
                name='city'
                component={Input}
                placeholder='Enter City'
                tabIndex={0}
              />
              <ErrorMessage name='city' component='div' className='text-danger mt-2' />
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <label className='form-label' htmlFor='state'>
                State/Province <span className='text-danger'>*</span>
              </label>
              <Field
                type='text'
                name='state'
                component={Input}
                placeholder='Enter State/Province'
                tabIndex={0}
              />
              <ErrorMessage name='state' component='div' className='text-danger mt-2' />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label className='form-label' htmlFor='country'>
                Country <span className='text-danger'>*</span>
              </label>
              <Field
                type='text'
                name='country'
                component={Input}
                placeholder='Enter Country'
                disabled={formik?.values?.zipcode === '' ? false : true}
                tabIndex={0}
              />
              <ErrorMessage name='country' component='div' className='text-danger mt-2' />
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <label className='form-label' htmlFor='zipcode'>
                Zip Code <span className='text-danger'>*</span>
              </label>
              <Field
                type='string'
                name='zipcode'
                component={Input}
                placeholder='Enter Zipcode'
                tabIndex={0}
              />
              <ErrorMessage name='zipcode' component='div' className='text-danger mt-2' />
            </div>
          </div>
        </div>

        {isModel && (
          <div className='row'>
            <div className='col-md-6'>
              <div className='form-group'>
                <label className='form-label'>
                  Industries <span className='text-danger'>*</span>
                </label>
                <CustomSelect
                  options={sectorList}
                  isMulti={true}
                  value={sectorList.filter((option: any) => selectedSectors.includes(option.value))}
                  name='sectors'
                  placeholder='Select Industry'
                  menuPosition={'fixed'}
                  onChange={handleSectorChange}
                  classNamePrefix='react-custom-multi-select'
                  styles={customSelectHoverStyles}
                  tabIndex={0}
                  onBlur={() => {
                    handleBlur({target: {name: 'sectors'}})
                  }}
                />
                <ErrorMessage name='sectors' component='div' className='text-danger mt-2' />
              </div>
            </div>

            <div className='col-md-6'>
              <div className='form-group'>
                <label className='form-label'>
                  Team Size <span className='text-danger'>*</span>
                </label>
                <CustomSelect
                  options={teamSizeArray}
                  name='team_size_id'
                  menuPosition={'fixed'}
                  tabIndex={0}
                  onChange={(option: any) => {
                    let event = {
                      target: {
                        name: 'team_size_id',
                        value: option?.value,
                      },
                    }
                    handleChange(event)
                  }}
                  classNamePrefix='react-custom-select'
                  styles={customSelectHoverStyles}
                  onBlur={() => {
                    handleBlur({target: {name: 'type'}})
                  }}
                />
                <ErrorMessage name='team_size_id' component='div' className='text-danger mt-2' />
              </div>
            </div>
          </div>
        )}

        {isPhoneVerifyDialog && (
          <FieldEditDialog
            isOpenDialog={isPhoneVerifyDialog}
            mode='mobile'
            handleClose={handleCloseDialog}
            onHideDialog={onHideDialog}
            stepStartingNumber={1}
            newPhoneNumber={values.phone}
            newCountryCode={values.country_code}
            newEmail={values.email}
            signUpResendOTPPayload={{
              mobile_no: `+${values?.country_code}${values?.phone}`,
              mode: 'mobile',
              ...(!firstTimeClicked &&
                !values.is_already_existing_user &&
                !values.is_existing_phone_user &&
                values.user_id && {user_id: values.user_id}),
            }}
            signUpVerifyOTPPayload={signUpVerifyOTPPayload}
            handleverifiedOTP={handleverifiedOTP}
          />
        )}
        {isEmailVerifyDialog && (
          <FieldEditDialog
            isOpenDialog={isEmailVerifyDialog}
            mode='email'
            handleClose={handleCloseDialog}
            onHideDialog={onHideDialog}
            stepStartingNumber={1}
            newPhoneNumber={values.phone}
            newCountryCode={values.country_code}
            newEmail={values.email}
            signUpResendOTPPayload={{
              email: values?.email,
              mode: 'email',
              ...(!firstTimeClicked &&
                !values.is_already_existing_user &&
                !values.is_existing_email_user &&
                values.user_id && {user_id: values.user_id}),
            }}
            signUpVerifyOTPPayload={signUpVerifyOTPPayload}
            handleverifiedOTP={handleverifiedOTP}
          />
        )}
      </div>
    </>
  )
}

export {Step1}
